import { useState, useContext } from 'react'
import '../SignIn/signin.css'

import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import logo from '../../assets/treks.png'

import { AuthContext } from '../../contexts/auth';

export default function SignUp(){
    const [name, setName] = useState('');
    const [username, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const {signUp, loadingAuth}  = useContext(AuthContext);

    async function handleSubmit(e){
        e.preventDefault();

        if(name !== '' && email !== '' && password !== '' && username !== ''){
            await signUp(email,password,username, name)
        }
    }

    return(
        <div className="container-fluid  d-flex justify-content-center align-items-center">
                <div className='login-area'>
                <img src={logo} alt='Logo do sistema Trek' className="w-50 img-fluid mt-3 mb-4"/>

                <form onSubmit={handleSubmit}>
                    <h1 className="w-75 m-auto mb-3 text-center">Nova Conta</h1>
                    <div className="w-75 m-auto mb-3">
                        <input className="inpt" type='text' placeholder='Nome completo' value={name}
                        onChange={(e) => setName(e.target.value)}/>
                    </div>

                    <div className="w-75 m-auto mb-3">
                        <input className="inpt" type='text' placeholder='Nome de usuário' value={username}
                        onChange={(e) => setUserName(e.target.value)}/>
                    </div>

                    <div className="w-75 m-auto mb-3">
                        <input className="inpt" type='text' placeholder='usuario@email.com' value={email}
                        onChange={(e) => setEmail(e.target.value)}/>
                    </div>

                    <div className="w-75 m-auto mb-3">
                        <input className="inpt" type='password' placeholder='********' value={password}
                        onChange={(e) => setPassword(e.target.value)}/>
                    </div>

                        <button type='submit' className="w-75 m-auto btn-block">{loadingAuth ? 'Carregando...' : 'Cadastrar'}</button> 

                </form>

                <Link to="/" className="linkk d-block mt-3 mb-3 text-center">Já possui uma conta? Faça login.</Link>
                </div>
                </div>
    );
}